module.exports = __webpack_public_path__ + "img/logovertical-us.1858443c.jpg";